//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Not functional on purpose: a functional wrapper resolves the modal content
// by name through the modals container, which was created at start-up. A
// plugin installed later (vuejs-clipper calls Vue.mixin) replaces the global
// component registry, and components registered after that, like the buyer
// cabinet ones, were invisible there: the modal opened empty.
export default {
  name: 'ModalWrapper',
  inheritAttrs: false,
  props: ['info', 'classes'],
}
